import { useContext } from "react";
import makeContextError from "./makeContextError";
import { Context } from "./ReCaptchaProvider";
const useSkipInjectionDelay = () => {
  const context = useContext(Context);
  return () => {
    const forceInjectScript = context?.injectScript.current ?? null;
    if (forceInjectScript !== null) {
      forceInjectScript();
      return null;
    }
    return makeContextError("");
  };
};
var useSkipInjectionDelay_default = useSkipInjectionDelay;
export {
  useSkipInjectionDelay_default as default
};
